import React from 'react';
import { ModalContent } from 'fronton-react';
import { List, ListItem, ModalHeader, Typography } from 'common/components';
import {
  kitchenUtpSectionModalContent,
  kitchenUtpSectionModalList,
  kitchenUtpSectionModalText,
} from '../../kitchen-utp-section-styles';

export const Manager: React.FC = () => (
  <>
    <ModalHeader title="Персональный менеджер" />
    <ModalContent className={kitchenUtpSectionModalContent}>
      <Typography className={kitchenUtpSectionModalText} variant="m" size="body_long" adaptive={false}>
        Выбор кухни&nbsp;&mdash; важный процесс. Поэтому мы&nbsp;обязательно предоставим вам услуги
        персонального менеджера&nbsp;&mdash; это бесплатно.
      </Typography>
      <Typography className={kitchenUtpSectionModalText} variant="m" size="body_long" adaptive={false}>
        Чем полезен менеджер?
      </Typography>
      <List className={kitchenUtpSectionModalList} listStyle="disc">
        <ListItem>
          <Typography variant="m" size="body_long" adaptive={false}>
            Обеспечит прозрачность процесса&nbsp;&mdash; от&nbsp;первой консультации до&nbsp;завершения
            установки
          </Typography>
        </ListItem>
        <ListItem>
          <Typography variant="m" size="body_long" adaptive={false}>
            Учтёт все пожелания и&nbsp;поможет создать кухню вашей мечты
          </Typography>
        </ListItem>
        <ListItem>
          <Typography variant="m" size="body_long" adaptive={false}>
            Всегда на&nbsp;связи и&nbsp;ответит на&nbsp;вопросы по&nbsp;проекту
          </Typography>
        </ListItem>
      </List>
    </ModalContent>
  </>
);
